import React from 'react';
import classNames from 'classnames';
import { REVIEW_RATINGS } from '../../util/types';
import { roundRatingToHalf } from '../../util/reviewRequestUtils';

import { IconReviewStar } from '../../components';

import css from './ReviewRating.module.css';

const fillLevelForStar = (rating, starIndex) => {
  const starNumber = starIndex + 1;
  const amount = Math.min(1, Math.max(0, rating - (starNumber - 1)));
  if (amount >= 1) return 1;
  if (amount >= 0.5) return 0.5;
  return 0;
};

/**
 * Star rating display (supports half-star averages when allowHalf is true).
 */
const ReviewRating = props => {
  const { className, rootClassName, reviewStarClassName, rating, allowHalf = false } = props;
  const classes = classNames(rootClassName || css.root, className);
  const numericRating = allowHalf ? roundRatingToHalf(rating) : Math.round(Number(rating) || 0);

  return (
    <span className={classes} title={`${numericRating}/5`}>
      {REVIEW_RATINGS.map((star, index) => {
        const fillLevel = allowHalf ? fillLevelForStar(numericRating, index) : star <= numericRating ? 1 : 0;

        if (fillLevel === 1) {
          return (
            <IconReviewStar
              key={`star-${star}`}
              className={reviewStarClassName}
              isFilled
            />
          );
        }

        if (fillLevel === 0.5) {
          return (
            <span key={`star-${star}`} className={css.starWrap} aria-hidden>
              <IconReviewStar className={reviewStarClassName} isFilled={false} />
              <span className={css.starHalf}>
                <IconReviewStar className={reviewStarClassName} isFilled />
              </span>
            </span>
          );
        }

        return (
          <IconReviewStar
            key={`star-${star}`}
            className={reviewStarClassName}
            isFilled={false}
          />
        );
      })}
    </span>
  );
};

export default ReviewRating;
